<template>
    <path fill-rule="evenodd" d="M23.91 0c.581 0 1.074.203 1.48.61.407.406.61.899.61 1.48v14.624c0 .29-.102.537-.305.74-.203.203-.422.315-.713.315-.29 0-.563-.112-.767-.315-.203-.203-.215-.39-.215-1.454V2H2v22h14c.943 0 1.251.012 1.454.215.203.204.305.45.305.74s-.102.537-.305.74c-.203.203-.45.305-.74.305H2.09c-.58 0-1.073-.203-1.48-.61C.203 24.985 0 24.492 0 23.91V2.09C0 1.508.203 1.015.61.61 1.015.202 1.508 0 2.09 0h21.82zm-7.582 14.839l5.386 5.385c.19.21.286.458.286.745 0 .286-.1.53-.3.73-.201.2-.445.301-.731.301-.287 0-.535-.105-.745-.315l-5.385-5.386-2.951 2.98c-.172.172-.363.214-.573.129-.21-.086-.315-.253-.315-.502v-6.875c0-.286.1-.53.3-.73.201-.2.445-.301.731-.301h6.904c.23 0 .387.105.473.315.085.21.043.401-.13.573l-2.95 2.95z"/>
</template>

<script>
export default {
    name: 'includeIcon',
    beforeMount() {
        this.$parent.$emit('size', '0 0 26 26');
    }
};
</script>
